/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        27/06/2022 09:12
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import FormComponent from './components/form.component'

document.addEventListener('DOMContentLoaded', () => {
    new FormComponent()
})
